module.exports = __webpack_public_path__ + "static/img/process3.d488994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/process/process3.jpg
// module id = 0p/2
// module chunks = 0